import { Radio } from 'antd'
import styled from "styled-components";

export const StyledRadioGroup = styled(Radio.Group)`

`

export const StyledRadioButton = styled(Radio)`

`